import { CostAccountingController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Shows the cost accounting details for the calculation.
 * @example
 * ```html
 * <salaxy-cost-accounting current="calc.accounting.dimensions" scope="calculation"></salaxy-cost-accounting>
 * ```
 */
export class CostAccounting extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = {
      /** Dimension values for edit. */
      current: "<",

      /** Possible inherited dimensions values from upper lever (e.g. calc level to rows) */
      inherited: "<",

      /** Forced read only state */
      readOnly: "<",
      /**
       * Optional CostAccountingDimensionDefinitions
       * If not set, cost accounting dimensions and their options are read from the settings.
       */
      dimensions: "<",
      /**
       * Scope for the cost accounting: calculation or row.
       */
      scope: "@",

      /**
       * Style of the inputs.
       * Supports empty or 'openClose'. Only available when not readOnly
       */
      inputMode: "@"
    };

    /** Uses the CostAccountingController */
    public controller = CostAccountingController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/calc/CostAccounting.html";

}
